import {
  HIDE_MODAL_FRESH,
  PAGE_REQUEST_FRESH,
  SET_IS_ELIGIBLE_FRESH,
  SHOW_MODAL_FRESH,
  SUBMIT_FORM_FRESH,
} from './constants';

export function pageRequest() {
  return { type: PAGE_REQUEST_FRESH, payload: {} };
}

export function setIsEligible(isEligible) {
  return { type: SET_IS_ELIGIBLE_FRESH, payload: { isEligible } };
}

export function showModal() {
  return { type: SHOW_MODAL_FRESH, payload: {} };
}

export function hideModal() {
  return { type: HIDE_MODAL_FRESH, payload: {} };
}

export function submitQuestion(questions) {
  return { type: SUBMIT_FORM_FRESH, payload: { questions } };
}
